import React, { ReactNode } from 'react';

import { StickyHeaderLinksBlockData } from 'api/cms';
import Box from 'components/Box';
import { PrimaryButtonLink, PrimaryButtonRouterLink } from 'components/Button';
import Icon from 'components/Icon/Icon';
import { isEmpty } from 'utils/functional';
import { isUrlWithProtocol } from 'utils/url';

import StickyHeaderLinks from './StickyHeaderLinks';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const ExternalLink = ({
  href,
  children,
}: {
  href: string;
  children: ReactNode | null | undefined;
}) => (
  <PrimaryButtonLink href={href} target="_blank">
    {children}
    <Box transform="translateY(1px)" display="inline-block" ml="6px">
      <Icon name="external-link" width={12} stroke="currentColor" />
    </Box>
  </PrimaryButtonLink>
);

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const StickyHeaderLinksBlock = ({
  data: { links, buttonText, buttonUrl },
}: {
  data: StickyHeaderLinksBlockData;
}) => {
  const hasButton = !isEmpty(buttonUrl) && !isEmpty(buttonText);
  return (
    <StickyHeaderLinks
      links={links}
      button={
        hasButton &&
        (buttonUrl && isUrlWithProtocol(buttonUrl) ? (
          <ExternalLink href={buttonUrl}>{buttonText}</ExternalLink>
        ) : (
          <PrimaryButtonRouterLink to={buttonUrl}>
            {buttonText}
          </PrimaryButtonRouterLink>
        ))
      }
    />
  );
};

// eslint-disable-next-line import/no-default-export
export default StickyHeaderLinksBlock;
